<script setup lang="ts">

import {onMounted, ref, useTemplateRef} from "vue";
import {TextInput, useClose} from "@hantera/design-system";
import useBackend from "@/composition/useBackend";
import {ViewContext} from "@hantera/portal-app";

const props = defineProps<{
  viewContext: ViewContext
}>()

const input = ref('')
const inputElem = useTemplateRef<InstanceType<typeof TextInput>>('inputElem')
const close = useClose()
const { queries } = useBackend();

onMounted(() => {
  inputElem.value?.select()
})

async function submit() {
  props.viewContext.state.transientQuery!.name = input.value

  const savedQuery = await queries.saveQuery(props.viewContext.state.transientQuery!);
  console.log(savedQuery);
  if (savedQuery?.id) {
    props.viewContext.state.transientQuery = undefined
    props.viewContext.navigate('/query', {
      query: {
        id: savedQuery.id
      },
      state: props.viewContext.state
    })
  }
  
  close()
}

</script>

<template>
  <form @submit.prevent.stop="submit">
    <TextInput v-model="input" ref="inputElem" />
    <input type="submit" class="button-primary" value="Save" />
  </form>
</template>

<style scoped>

form {
  display: grid;
  grid-template-columns: 1fr min-content;
  gap: 5px;
  min-width: 250px;
}

</style>